// Shown on the login page after the user is redirected there by a session
// expiry. Shared so SessionExpiredWatcher and ProtectedRoute stay in sync.
export const INACTIVITY_MESSAGE =
  "You have been logged out due to inactivity. Please log in again or proceed as a guest.";
